.base {
  container-type: inline-size;
  container-name: base;
  background-color: var(--body-bg-color);
  overflow: hidden;

  border-radius: var(--offer-border-radius);
  border: 1px solid var(--offer-border-color);

  font-family: var(--font-family);
}
